import React, { useState } from "react";
import { notInitialized } from "react-redux/es/utils/useSyncExternalStore";
import '../../assets/styles.css';

function RuleTypeImg( {ruleTypeId} ) {
  const icons = {
    1: 'condition.png',
    2: 'variable.png',
    6: 'detail.png',
    17: 'loop.png',
    22: 'foreach.png'
  }
  if (!(ruleTypeId in icons)) return;
  const iconNames = {
    1: 'Condition',
    2: 'Variable',
    6: 'Detail',
    17: 'Loop',
    22: 'For Each'
  }

  const image = icons[ruleTypeId];
  const iconName = iconNames[ruleTypeId];

  return (
    <img className="pr-1 rule-type-img" src={`/rules/${image}`} title={iconName}/>
  )
}

const TreeNode = ({ node, onItemSelect, selectedId, setSelectedId }) => {
  const [isOpen, setIsOpen] = useState(true);
  const hasChildren = node.children && node.children.length > 0;
  const isSelected = selectedId === node.id;
  const isRulesetGroup = node.parentId === -1;

  const handleSelect = (e) => {
    e.stopPropagation();
    setSelectedId(node.id);
    onItemSelect(node);
  };

  return (
    <li>
      <div
        className={`flex items-center cursor-pointer rounded ${
          isSelected ? "bg-blue-100" : ""
        }`}
      >
        {hasChildren ? (
          <span
            className={`transform transition-transform ${
              isOpen ? "rotate-90" : ""
            }`}
            onClick={() => hasChildren && setIsOpen(!isOpen)}
          >
            ▶
          </span>
        ) : (
          <span />
        )}

        <div onClick={handleSelect} className={`no-wrap ${isRulesetGroup ? "headerBlue" : ""}`}>
          <RuleTypeImg ruleTypeId={node.ruleTypeId} />
          {node.parentId > 0 ? node.id + ': ' : ''}{node.display}{" "}
          <span className="text-sm text-gray-500">{node.description}</span>
        </div>
      </div>

      {hasChildren && isOpen && (
        <ul className="ml-2 border-l border-gray-300 pl-2">
          {node.children 
          ? node.children.map((child) => (
            <TreeNode
              key={child.id}
              node={child}
              onItemSelect={onItemSelect}
              selectedId={selectedId}
              setSelectedId={setSelectedId}
            />
          )) : null}
        </ul>
      )}
    </li>
  );
};

const TreeView = ({ data, onItemSelect }) => {
  const [selectedId, setSelectedId] = useState(null);

  return (
    <ul className="list-none smaller">
      {data ? data.map((node) => (
        <TreeNode
          key={node.id}
          node={node}
          onItemSelect={onItemSelect}
          selectedId={selectedId}
          setSelectedId={setSelectedId}
        />
      )) : null}
    </ul>
  );
};

export default TreeView;
